export enum PriceModifierAction {
  NewPrice = 'NewPrice',
  Amount = 'Amount',
  Percent = 'Percent',
}
